import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Wrapper from "../components/Wrapper";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";

import TablePagination from "@mui/material/TablePagination";
import { Accordion, AccordionDetails, AccordionSummary, Switch, FormControlLabel } from "@mui/material";
import HistoryFilter from "../components/HistoryFilter";
import { Helmet } from "react-helmet";
import { history, history1, historyHeader, menu, graphics, telecomunication } from "../translate";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Graphics from "../components/Graphics";
import { useDispatch, useSelector } from "react-redux";
import { historyCompleted, historyRequest } from "../store/actions/history";
import { rowHasSpeechBuddy } from "../helpers/speechBuddy";
import qs from "query-string";
import Api from "../Api";
import Utils from "../Utils";
import { REACT_APP_API_URL } from "../config";
import _ from 'lodash'
import HistoryFilter1 from "../components/HistoryFilter1";
import AudioPlayerBar from "../components/AudioPlayerBar";
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import PauseCircleIcon from '@mui/icons-material/PauseCircle';
import CachedIcon from '@mui/icons-material/Cached';
import HistoryIcon from '@mui/icons-material/History';
import Loader from "../components/Loader";
import Cookies from "js-cookie";
import IconForCall from "../components/IconForCall";
import { Tooltip } from "react-tooltip";
import HistoryLine from "../components/HistoryLine";
import Emotions from "../components/Emotions";
import { toast } from "react-toastify";
import moment from "moment";
import ChooseEmotion from "../components/ChooseEmotion";
import HistoryChats from '../components/new_component/HistoryChats';
import { hasHistoryView, hasReportView, hasEmployeeTelegram, hasEmployeeWhatsApp, hasTelegramConnected, hasWhatsAppConnected, getEmployeePermissions, getEmployeeBuddy, canListenToRecording as canListenToRecordingRow } from '../helpers/employeePermissions';
import { getHistoryPageSize, setHistoryPageSize } from '../helpers/historyPageSize';
import { profileEmployeeRequest } from '../store/actions/users';
import { greenTheme } from '../helpers/style';
import TelegramIcon from '@mui/icons-material/Telegram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const ARMENIAN_MOBILE_CODES = ['33', '41', '43', '44', '55', '77', '88', '91', '93', '94', '95', '96', '97', '98', '99'];

function sipUser(fr) {
    const raw = String(fr ?? '');
    const start = raw.indexOf(':');
    const end = raw.indexOf('@');
    if (start !== -1 && end > start) return raw.slice(start + 1, end);
    return raw;
}

function withCallerNumber(number, fr) {
    const value = String(number ?? '');
    const code = value.startsWith('374')
        ? value.slice(3, 5)
        : value.startsWith('0')
            ? value.slice(1, 3)
            : '';
    if (code && !ARMENIAN_MOBILE_CODES.includes(code) && value.length === 11) {
        return sipUser(fr) || value;
    }
    return value;
}

function withDestinationNumber(number) {
    const value = String(number ?? '');
    if (value.startsWith('374')) {
        const code = value.slice(3, 5);
        if (!ARMENIAN_MOBILE_CODES.includes(code)) return '174' + value.slice(3);
    } else if (value.startsWith('0')) {
        const code = value.slice(1, 3);
        if (!ARMENIAN_MOBILE_CODES.includes(code)) return '174' + value.slice(1);
    }
    return value;
}

function parseCallHistory(value) {
    if (Array.isArray(value)) return value
    if (typeof value !== 'string' || !value.trim()) return []
    try {
        const parsed = JSON.parse(value)
        return Array.isArray(parsed) ? parsed : []
    } catch (e) {
        return []
    }
}

function isTransferredType(type) {
    return String(type || '').toLowerCase().includes('transfer')
}

function callHistoryRecFile(row) {
    const file = String(row?.rec_file ?? '').trim()
    if (!file || file === 'null') return ''
    return file.replace(/\.mp3$/i, '')
}

function CallHistoryList({ value, showWait, extension, playingId, textLoading, onPlay, onText, playDisabled }) {
    const list = parseCallHistory(value)
    if (!list.length) return null
    const originExtension = extension != null && extension !== '' ? String(extension) : ''
    const langIndex = +localStorage.getItem('atsLang') || 1
    return list.map((entry, index) => {
        const row = entry && typeof entry === 'object' ? entry : {}
        const transferred = typeof entry === 'object' && isTransferredType(row.type)
        const previous = index > 0 && list[index - 1] && typeof list[index - 1] === 'object' ? list[index - 1] : null
        const previousDestination = String(previous?.destination ?? '')
        const outboundTransfer = String(row.transfer_direction || '').toLowerCase() === 'outbound'
        const transferredExtension = outboundTransfer
            ? (row.buddy || '')
            : previousDestination.length >= 8
                ? (previousDestination.length === 8 && /^\d+$/.test(previousDestination) ? `0${previousDestination}` : previousDestination)
                : (row.buddy || '')
        const caller = typeof entry !== 'object'
            ? String(entry)
            : (transferred ? transferredExtension : originExtension)
        const destination = String(row.destination ?? '')
        const shownDestination = destination.length === 8 && /^\d+$/.test(destination) ? `0${destination}` : destination
        const status = String(row.status || '').toUpperCase()
        const answeredShort = (status === 'ANSWERED' || status === 'BUSY') && destination.length > 0 && destination.length < 7
        const receiver = answeredShort
            ? `${shownDestination} -> ${row.buddy || ''}`
            : (row.transfer_to || shownDestination || row.filename || row.buddy || '')
        const recFile = callHistoryRecFile(row)
        const canPlay = !!recFile && !playDisabled
        const isPlaying = canPlay && String(playingId) === recFile
        return (
            <TableRow key={row.id || row.uniqueid || index} className="sip_num" style={{ background: '#f7f7f7' }}>
                <TableCell align="center">{index + 1}</TableCell>
                <TableCell align="center" style={{ width: 100 / 8 + '%', fontSize: 10 }}>
                    {row.type || ''}
                </TableCell>
                <TableCell align="center" style={{ width: 100 / 8 + '%', color: transferred ? '#b45309' : undefined, fontWeight: transferred ? 600 : undefined }}>{caller}</TableCell>
                <TableCell align="center" style={{ width: 100 / 8 + '%' }}>
                    {typeof entry === 'object' ? Utils.secToHours(Number(row.duration) || 0) : ''}
                </TableCell>
                {showWait ? (
                    <TableCell align="center" style={{ width: 100 / 8 + '%' }}>
                        {Number(row.billsec) || 0} {history1.seconds[langIndex]}
                    </TableCell>
                ) : null}
                <TableCell align="center" style={{ width: 100 / 8 + '%' }}>
                    {row.line && row.line !== 'null' && row.line !== 'umob' ? row.line : row.ext_num ? row.ext_num[0] : ''}
                </TableCell>
                <TableCell align="center" style={{ width: 100 / 8 + '%' }}>{row.in_num || ''}</TableCell>
                <TableCell align="center" style={{ width: 100 / 8 + '%' }}>
                    {row.virtual ? Utils.displayShortNumber(row.virtual) : (row.short || row.short_number ? Utils.displayShortNumber(row.short || row.short_number) : '')}
                </TableCell>
                <TableCell align="center" style={{ width: 100 / 8 + '%' }}>{row.status || ''}</TableCell>
                <TableCell align="center" style={{ width: 100 / 8 + '%' }}>
                    {receiver}
                </TableCell>
                <TableCell align="center" style={{ width: 100 / 8 + '%' }}>
                    {row.rate ? row.rate : <DoNotDisturbIcon style={{ color: '#ccc' }} />}
                </TableCell>
                <TableCell align="center" style={{ width: 100 / 8 + '%', cursor: canPlay ? 'pointer' : 'default' }}>
                    <span className="d-flex history_audio" style={{ justifyContent: 'center' }}>
                        {canPlay ? (
                            isPlaying ? (
                                <PauseCircleIcon onClick={() => onPlay?.(recFile)} style={{ color, cursor: 'pointer' }} />
                            ) : (
                                <PlayCircleIcon onClick={() => onPlay?.(recFile)} style={{ color, cursor: 'pointer' }} />
                            )
                        ) : (
                            <PlayCircleIcon style={{ color: '#ccc' }} />
                        )}
                        {recFile && !playDisabled ? (
                            String(textLoading) === recFile ? (
                                <Loader size={20} />
                            ) : (
                                <ChatBubbleIcon onClick={() => onText?.(recFile)} style={{ color: '#52658c', cursor: 'pointer' }} />
                            )
                        ) : (
                            <ChatBubbleIcon style={{ color: '#ccc', pointerEvents: 'none' }} />
                        )}
                    </span>
                </TableCell>
            </TableRow>
        )
    })
}

const { REACT_APP_SERVER } = process.env;
const primaryColor = REACT_APP_SERVER === 'ATS' ? '#0b73b9' : (greenTheme?.primary || '#7ebc0a');


let color = REACT_APP_SERVER === 'ATS' ? '#0973b9' : '#7ebc0a'

function History(props) {
    let link = REACT_APP_API_URL + ((REACT_APP_SERVER === 'Ucom' || REACT_APP_SERVER === 'V-office') ? '/rest' : '')
    const [choose, setChoose] = useState(null)
    const [interacted, setInteracted] = useState(false)
    const [expanded, setExpanded] = useState(true)
    const [select, setSelect] = useState({})
    const [historyD, setHistory] = useState({})
    const [emotions, setEmotions] = useState({})
    const [loading, setLoading] = useState(0)
    const [trackIndexSet, setTrackIndex] = useState(0)
    const [sticky, setSticky] = useState(true)
    const historyData1 = useSelector(state => state.history.historyData1)
    const duration = useSelector(state => state.history.duration)
    const historyStatus = useSelector(state => state.history.historyStatus)
    const count = useSelector(state => state.history.count)
    const page = useSelector(state => state.history.page)
    const speechbuddy = useSelector(state => state.history.speechbuddy)
    const completed = useSelector(state => state.history.completed)
    const [telegram, setTelegram] = useState(null)
    const [ursTelegramCount, setUrsTelegramCount] = useState(0)
    const [ursWhatsAppCount, setUrsWhatsAppCount] = useState(0)
    const employeeData = useSelector(state => state.users.employeeData)
    const dispatch = useDispatch()
    const location = useLocation()
    const navigate = useNavigate()

    const permissions = getEmployeePermissions(employeeData);
    const employeeBuddy = getEmployeeBuddy(employeeData);
    const showCallHistoryNav = hasHistoryView(employeeData);
    const showReportNav = hasReportView(employeeData);
    const restrictToOwnHistory = !!(employeeBuddy && permissions.includes('call_history_own') && !permissions.includes('call_history_all'));

    const canListenToRecording = useCallback(
        (row) => canListenToRecordingRow(employeeData, row),
        [employeeData]
    );

    useEffect(() => {
        if (!Cookies.get('buddy') && !Cookies.get('member')) return;
        if (employeeData?.buddy && employeeData?.permission) return;
        dispatch(profileEmployeeRequest());
    }, [dispatch, employeeData?.buddy, employeeData?.permission]);

    useEffect(() => {
        if (!restrictToOwnHistory || !employeeBuddy) return;
        const q = qs.parse(location.search, { arrayFormat: 'comma' });
        if (q.caller !== employeeBuddy) {
            q.caller = employeeBuddy;
            navigate(`${location.pathname}?${qs.stringify(q, { arrayFormat: 'comma', skipEmptyString: true })}`, { replace: true });
            const yourDate = new Date();
            const offset = yourDate.getTimezoneOffset();
            yourDate.setTime(yourDate.getTime() - (offset * 60 * 1000));
            const today = yourDate.toISOString().split('T')[0];
            dispatch(historyRequest(getHistoryPageSize(q.limit), q.page || 1, {
                endTime: q.endTime || today,
                startTime: q.startTime || today,
                number: q.number || '',
                did: q.did || '',
                caller: employeeBuddy,
                status: q.status || '',
                disposition: q.disposition || '',
                line: q.line || '',
                direction: q.direction || '',
                period: q.period || '',
                virtual: q.virtual != null && q.virtual !== '' ? q.virtual : ''
            }));
        }
    }, [restrictToOwnHistory, employeeBuddy, location.pathname, location.search, dispatch])

    const profile = useSelector(state => state.users.ursData)
    const profileData = useSelector(state => state.users.userData)
    const hasBuddyTelegrams = hasEmployeeTelegram(employeeData);
    const telegramIdForLink = hasBuddyTelegrams
        ? (employeeData.telegrams[0]?.id ?? null)
        : telegram;
    const showTelegramNav = hasTelegramConnected(employeeData, { ursTelegramAccountsCount: ursTelegramCount });
    const showWhatsappNav = hasWhatsAppConnected(employeeData, { ursWhatsAppAccountsCount: ursWhatsAppCount });

    useEffect(() => {
        if (hasBuddyTelegrams && employeeData.telegrams[0]?.id != null) {
            setTelegram(employeeData.telegrams[0].id);
        }
    }, [hasBuddyTelegrams, employeeData?.telegrams?.length, employeeData?.telegrams?.[0]?.id]);

    useEffect(() => {
        (async () => {
            try {
                if (hasBuddyTelegrams) return;
                const { data } = await Api.telegramGet();
                const accounts = data?.data ?? data ?? [];
                const list = Array.isArray(accounts) ? accounts : [];
                setUrsTelegramCount(list.length);
                setTelegram(list.length > 0 ? list[0].id : null);
            } catch (e) {
                setUrsTelegramCount(0);
                setTelegram(null);
            }
        })();
    }, [hasBuddyTelegrams]);

    useEffect(() => {
        (async () => {
            try {
                if (hasEmployeeWhatsApp(employeeData)) {
                    setUrsWhatsAppCount(employeeData.whatsapps?.length ?? employeeData.whatsapp?.length ?? 0);
                    return;
                }
                const { data } = await Api.whatsappGet();
                const accounts = data?.data ?? data ?? [];
                const list = Array.isArray(accounts) ? accounts : [];
                setUrsWhatsAppCount(list.length);
            } catch (e) {
                setUrsWhatsAppCount(0);
            }
        })();
    }, [employeeData?.whatsapps, employeeData?.whatsapp]);

    const query = qs.parse(location.search, { arrayFormat: 'comma' });
    const historyLimit = getHistoryPageSize(query.limit);
    const [isOpen, setIsOpen] = useState('')
    const [callHistoryOpen, setCallHistoryOpen] = useState('')
    let counter = +((page || 1) - 1) * historyLimit;
    const handleLimit = useCallback(async (event) => {
        const limit = setHistoryPageSize(parseInt(event.target.value, 10));
        const nextQuery = { ...qs.parse(location.search, { arrayFormat: 'comma' }), limit, page: 1 };
        navigate(`?${qs.stringify(nextQuery, {
            arrayFormat: 'comma',
            skipEmptyString: true,
        })}`);
        const callerVal = restrictToOwnHistory && employeeBuddy ? employeeBuddy : (nextQuery.caller || '');
        await dispatch(historyRequest(limit, 1, {
            endTime: nextQuery.endTime,
            startTime: nextQuery.startTime,
            number: nextQuery.number || '',
            did: nextQuery.did || '',
            caller: callerVal,
            status: nextQuery.status || '',
            disposition: nextQuery.disposition || '',
            line: nextQuery.line || '',
            direction: nextQuery.direction || '',
            period: nextQuery.period || '',
            virtual: nextQuery.virtual != null && nextQuery.virtual !== '' ? nextQuery.virtual : '',
            ...(nextQuery.member_all === 'true' && { member_all: true }),
        }))
        counter = 0;
    }, [location.search, restrictToOwnHistory, employeeBuddy, dispatch, navigate])
    const trackList = useMemo(() => {
        const list = [];
        historyD?.response?.docs?.forEach((row) => {
            if (row.items.length === 1) {
                const item = row.items[0];
                if (item.isAudio && (!Cookies.get('viewer') || profile?.isLimited) && canListenToRecording(item)) {
                    list.push({
                        src: link + '/history/audio?file=' + item.uniqueid + '&key=akNwNXN1U2k4bzdEQ09QU29KMUpYbXFiQTV5c3FmUm1MOUNheW5qWlYwOD0=',
                        id: item.uniqueid,
                        uniqueid: item.uniqueid,
                        linkedid: item.linkedid,
                        isEmotion: item.isEmotion,
                        isAudio: item.isAudio,
                        name: item?.start + '_' + item?.extension + '_' + item?.destination,
                        fname: item?.extension + '_' + item?.destination,
                        extension: item?.extension,
                        destination: item?.destination,
                        transfer_from: item?.transfer_from,
                        transfer_to: item?.transfer_to,
                        type: (item.line && item.line !== 'null') || item.ext_num ? 'Outgoing' : item.in_num ? 'Incoming' : ''
                    });
                }
            } else {
                row.items.forEach((r) => {
                    if (r.isAudio && (!Cookies.get('viewer') || profile?.isLimited) && canListenToRecording(r)) {
                        list.push({
                            src: link + '/history/audio?file=' + r.uniqueid + '&key=akNwNXN1U2k4bzdEQ09QU29KMUpYbXFiQTV5c3FmUm1MOUNheW5qWlYwOD0=',
                            id: r.uniqueid,
                            uniqueid: r.uniqueid,
                            linkedid: r.linkedid,
                            isEmotion: r.isEmotion,
                            isAudio: r.isAudio,
                            name: r?.start + '_' + r?.extension + '_' + r?.destination,
                            fname: r?.extension + '_' + r?.destination,
                            extension: r?.extension,
                            destination: r?.destination,
                            transfer_from: r?.transfer_from,
                            transfer_to: r?.transfer_to,
                            type: (r.line && r.line !== 'null') || r.ext_num ? 'Outgoing' : r.in_num ? 'Incoming' : ''
                        });
                    }
                });
            }
        });
        return list;
    }, [historyD, link, profile, canListenToRecording]);

    const audioRef = useRef(null);
    const [playingId, setPlayingId] = useState(null);
    const [currentTrack, setCurrentTrack] = useState(null);
    const [audioDuration, setAudioDuration] = useState(0);
    const [currentTime, setCurrentTime] = useState(0);
    const [volume, setVolume] = useState(1);
    const [speed, setSpeed] = useState(1);
    const speedRef = useRef(speed);
    useEffect(() => {
        speedRef.current = speed;
    }, [speed]);

    const stopAudioCard = useCallback(() => {
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
        }
        setPlayingId(null);
        setCurrentTime(0);
    }, []);

    const formatTime = useCallback((s) => {
        if (!s || !Number.isFinite(s)) return '0:00';
        const m = Math.floor(s / 60);
        const sec = Math.floor(s % 60);
        return `${m}:${sec < 10 ? '0' : ''}${sec}`;
    }, []);

    const formatFileSize = useCallback((bytes) => {
        if (bytes == null || bytes === 0) return '—';
        if (bytes < 1024) return `${bytes} B`;
        if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
        return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
    }, []);

    const formatFileDate = useCallback((value) => {
        if (!value) return '—';
        const d = value instanceof Date ? value : new Date(typeof value === 'number' ? value : value);
        if (Number.isNaN(d.getTime())) return '—';
        return d.toLocaleString();
    }, []);

    const handlePlayFile = useCallback((track) => {
        const fid = track?.id || track?.uniqueid;
        const src = track?.src;
        if (!fid || !src) return;
        const el = audioRef.current;
        if (!el) return;
        if (playingId === fid) {
            el.pause();
            setPlayingId(null);
            return;
        }
        try {
            el.src = src;
            el.load();
            el.playbackRate = speedRef.current;
            setCurrentTrack(track);
            setCurrentTime(0);
            setAudioDuration(0);
            setPlayingId(fid);
            const idx = trackList.findIndex(s => s.id === fid);
            if (idx !== -1) setTrackIndex(idx);
            setInteracted(true);
            el.play().catch(() => stopAudioCard());
        } catch (e) {
            stopAudioCard();
        }
    }, [playingId, trackList, stopAudioCard]);

    const handlePlayerPlayPause = useCallback(() => {
        const el = audioRef.current;
        if (!el || !currentTrack) return;
        if (playingId) {
            el.pause();
            setPlayingId(null);
        } else {
            const src = currentTrack?.src;
            if (src) {
                if (!el.src) {
                    el.src = src;
                    el.load();
                }
                el.playbackRate = speedRef.current;
                setPlayingId(currentTrack?.id || currentTrack?.uniqueid);
                el.play().catch(() => setPlayingId(null));
            }
        }
    }, [currentTrack, playingId]);

    const handleSeek = useCallback((_, value) => {
        const el = audioRef.current;
        if (!el || !audioDuration) return;
        const t = (Number(value) / 100) * audioDuration;
        el.currentTime = t;
        setCurrentTime(t);
    }, [audioDuration]);

    const handleDownloadFile = useCallback((track) => {
        if (!track?.src) return;
        fetch(track.src)
            .then(res => res.blob())
            .then(blob => {
                const urlObj = window.URL.createObjectURL(new Blob([blob]));
                const a = document.createElement('a');
                a.href = urlObj;
                a.download = (track?.name || track?.id) + '.mp3';
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(urlObj);
            })
            .catch(err => console.error('Download failed:', err));
    }, []);

    useEffect(() => {
        if (trackList.length === 0) {
            setCurrentTrack(null);
            setPlayingId(null);
            setTrackIndex(0);
            return;
        }
        const first = trackList[0];
        let idxToSet = 0;
        setCurrentTrack((prev) => {
            if (!prev) return first;
            const fid = prev?.id || prev?.uniqueid;
            idxToSet = trackList.findIndex((t) => (t?.id || t?.uniqueid) === fid);
            if (idxToSet >= 0) return prev;
            idxToSet = 0;
            return first;
        });
        setTrackIndex(idxToSet);
        const el = audioRef.current;
        if (!el) return;
        const onLoadedMetadata = () => {
            el.playbackRate = speedRef.current;
            setAudioDuration(el.duration);
        };
        const onTimeUpdate = () => setCurrentTime(el.currentTime);
        const onEnded = () => { setPlayingId(null); setCurrentTime(0); };
        el.addEventListener('loadedmetadata', onLoadedMetadata);
        el.addEventListener('timeupdate', onTimeUpdate);
        el.addEventListener('ended', onEnded);
        return () => {
            el.removeEventListener('loadedmetadata', onLoadedMetadata);
            el.removeEventListener('timeupdate', onTimeUpdate);
            el.removeEventListener('ended', onEnded);
        };
    }, [trackList]);

    useEffect(() => {
        const el = audioRef.current;
        if (el) el.volume = volume;
    }, [volume]);

    useEffect(() => {
        const el = audioRef.current;
        if (!el) return;
        el.playbackRate = speed;
    }, [speed, currentTrack?.src, currentTrack?.id, currentTrack?.uniqueid, playingId]);

    const progress = audioDuration > 0 ? (currentTime / audioDuration) * 100 : 0;
    const langIndex = +localStorage.getItem('atsLang') || 1;
    const playerLabel = currentTrack ? (currentTrack?.name || currentTrack?.fname || currentTrack?.id) : (langIndex === 2 ? 'Нет трека' : langIndex === 3 ? 'Երգ չկա' : 'No track');
    const currentTrackFid = currentTrack ? (currentTrack?.id || currentTrack?.uniqueid) : null;
    const currentIndex = currentTrackFid != null ? trackList.findIndex((t) => (t?.id || t?.uniqueid) === currentTrackFid) : -1;
    const canGoPrev = currentIndex > 0;
    const canGoNext = currentIndex >= 0 && currentIndex < trackList.length - 1;

    const handlePrev = useCallback(() => {
        if (!canGoPrev) return;
        const prevTrack = trackList[currentIndex - 1];
        if (prevTrack) handlePlayFile(prevTrack);
    }, [canGoPrev, currentIndex, trackList, handlePlayFile]);

    const handleNext = useCallback(() => {
        if (!canGoNext) return;
        const nextTrack = trackList[currentIndex + 1];
        if (nextTrack) handlePlayFile(nextTrack);
    }, [canGoNext, currentIndex, trackList, handlePlayFile]);

    const handleHistoryPlay = useCallback((recFile) => {
        const file = String(recFile || '').trim()
        if (!file) return
        handlePlayFile({
            src: link + '/history/audio?file=' + encodeURIComponent(file) + '&key=akNwNXN1U2k4bzdEQ09QU29KMUpYbXFiQTV5c3FmUm1MOUNheW5qWlYwOD0=',
            id: file,
            uniqueid: file,
            isAudio: true,
            name: file,
        })
    }, [handlePlayFile, link])

    const handleHistoryText = useCallback(async (recFile) => {
        const file = String(recFile || '').trim()
        if (!file) return
        try {
            setLoading(file)
            toast.info('Getting transcription...')
            const { data } = await Api.getHy(file)
            setEmotions({
                status: 'ok',
                data: data.data || data,
            })
            setLoading(0)
        } catch (e) {
            setLoading(0)
            const errorMessage = e.response?.data?.message || e.message || 'An error occurred'
            toast.error('Error occurred: ' + errorMessage)
        }
    }, [])

    const handleAudio = useCallback((r) => {
        if (r.isAudio && canListenToRecording(r)) {
            const track = trackList.find(s => s.id === r.uniqueid || s.uniqueid === r.uniqueid);
            if (track) handlePlayFile(track);
        }
    }, [trackList, handlePlayFile, canListenToRecording])

    const handleText = useCallback(async (r) => {
        try {
            if (!rowHasSpeechBuddy(r, speechbuddy)) return;
            if ((r.isAudio || r.src) && canListenToRecording(r)) {
                setLoading(r.uniqueid || r.id);
                if (r.isEmotion.via === 'emotion') {
                    const { data } = await Api.getEmotions(r.uniqueid || r.id);
                    setEmotions(data);
                    setLoading(0);
                } else {
                    // Handle transcription (wav, hy, etc.)
                    toast.info('Getting transcription...');
                    const { data } = await Api.getHy(r.uniqueid || r.id);
                    let transcriptionData = data.data || data;


                    // Update data with parsed transcriptionData
                    // Structure: { data: { segments: [...], text: "...", ... } }
                    const finalData = {
                        status: 'ok',
                        data: transcriptionData
                    };

                    // Open modal and show segments - modal opens automatically when setEmotions is called with truthy value
                    setEmotions(finalData);
                    setLoading(0);

                    // Mark as completed in Redux store
                    dispatch(historyCompleted({ id: r.linkedid }));
                }

            }
        } catch (e) {
            setLoading(0)
            const errorMessage = e.response?.data?.message || e.message || 'An error occurred';
            toast.error('Error occurred: ' + errorMessage)
        }
    }, [canListenToRecording, speechbuddy])
    const handleChangePage = useCallback(async (newPageIndex) => {
        const currentQuery = qs.parse(location.search, { arrayFormat: 'comma' });
        const limit = getHistoryPageSize(currentQuery.limit);
        const nextQuery = { ...currentQuery, page: newPageIndex + 1, limit };
        navigate(`?${qs.stringify(nextQuery, {
            arrayFormat: 'comma',
            skipEmptyString: true,
        })}`);
        counter = newPageIndex * limit;
        const callerVal = restrictToOwnHistory && employeeBuddy ? employeeBuddy : (nextQuery.caller || '');
        await dispatch(historyRequest(limit, nextQuery.page || 1, {
            endTime: nextQuery.endTime,
            startTime: nextQuery.startTime,
            number: nextQuery.number || '',
            did: nextQuery.did || '',
            caller: callerVal,
            status: nextQuery.status || '',
            disposition: nextQuery.disposition || '',
            line: nextQuery.line || '',
            direction: nextQuery.direction || '',
            period: nextQuery.period || '',
            virtual: nextQuery.virtual != null && nextQuery.virtual !== '' ? nextQuery.virtual : '',
            ...(nextQuery.member_all === 'true' && { member_all: true }),
        }))
    }, [location.search, restrictToOwnHistory, employeeBuddy, dispatch, navigate])
    useEffect(() => {
        (async () => {
            let yourDate = new Date()
            const currentQuery = qs.parse(location.search, { arrayFormat: 'comma' });
            const limit = getHistoryPageSize(currentQuery.limit);
            counter = +((currentQuery.page || 1) - 1) * limit;
            const offset = yourDate.getTimezoneOffset()
            yourDate = new Date(yourDate.getTime() - (offset * 60 * 1000))
            const callerVal = restrictToOwnHistory && employeeBuddy ? employeeBuddy : (currentQuery.caller || '');
            await dispatch(historyRequest(limit, currentQuery.page || 1, {
                endTime: currentQuery.endTime || yourDate.toISOString().split('T')[0],
                startTime: currentQuery.startTime || yourDate.toISOString().split('T')[0],
                number: currentQuery.number || '',
                did: currentQuery.did || '',
                caller: callerVal,
                status: currentQuery.status || '',
                disposition: currentQuery.disposition || '',
                line: currentQuery.line || '',
                direction: currentQuery.direction || '',
                period: currentQuery.period || '',
                virtual: currentQuery.virtual != null && currentQuery.virtual !== '' ? currentQuery.virtual : '',
                ...(currentQuery.member_all === 'true' && { member_all: true }),
            }))
        })()
    }, []);
    useEffect(() => {
        (async () => {
            try {
                const { data } = await Api.getAllowed();
                if (data?.inputNumber) {
                    if (REACT_APP_SERVER === 'Ucom') {
                        data.inputNumber.sip = (data.inputNumber.sip || []).filter(s => +s?.issip === 1);
                    }
                    setSelect(data.inputNumber);
                }
            } catch (e) {
                // ignore
            }
        })();
    }, []);
    useEffect(() => {
        // if (REACT_APP_SERVER === 'Ucom') {
        historyData1?.response?.docs?.map(row => {
            if (row?.items?.length === 1) {
                if (row?.items?.[0]?.extension?.split("-")?.length === 2 && (row?.items?.[0]?.extension?.split("-")?.[0] || row?.items?.[0]?.extension?.split("-")?.[1])) {
                    if (row?.items?.[0]?.extension?.split("-")?.[0]?.length === 7) {
                        row.items[0].ext_note = select?.sip?.find(s => +s?.number === +row?.items?.[0]?.extension?.split("-")?.[0])?.context
                    }
                    if (row?.items?.[0]?.extension?.split("-")?.[1]?.length === 7) {
                        row.items[0].ext_note = row?.items?.[0]?.ext_note + " - " + select?.sip?.find(s => +s?.number === +row?.items?.[0]?.extension?.split("-")?.[1])?.context
                    }
                    if (row?.items?.[0]?.extension?.split("-")?.[1]?.length === 11) {
                        row.items[0].extension = withCallerNumber(row?.items?.[0]?.extension?.replace('-', ''), row.items[0].fr)
                    }
                }
                if (row?.items?.[0]?.extension === '-anonymous') {
                    row.items[0].extension = withCallerNumber(row?.items?.[0]?.extension?.replace('-', ''), row.items[0].fr)
                }
                else if (row?.items?.[0]?.extension?.replace('-', '')?.length === 9 || row?.items?.[0]?.extension?.replace('-', '')?.length === 8) {
                    row.items[0].ext_note = select?.allowed?.find(s => +s?.number === +row?.items?.[0]?.extension?.replace('-', ''))?.context
                    if (row?.items?.[0]?.extension?.replace('-', '')?.length === 9) {
                        row.items[0].extension = withCallerNumber("374" + row?.items?.[0]?.extension?.replace('-', '')?.slice(1), row.items[0].fr)
                    } else {
                        row.items[0].extension = withCallerNumber("374" + row?.items?.[0]?.extension?.replace('-', ''), row.items[0].fr)
                    }
                }

                if (row?.items?.[0]?.destination?.split("-")?.length === 2 && row?.items?.[0]?.destination?.split("-")?.[1]?.length === 8) {
                    row.items[0].dest_note = select?.allowed?.find(s => +s?.number === +row?.items?.[0]?.destination?.split("-")?.[1])?.context
                    row.items[0].destination = withDestinationNumber("0" + row?.items?.[0]?.destination?.split("-")?.[1])
                } else if (row?.items?.[0]?.destination?.split("-")?.length === 2 && (!row?.items?.[0]?.destination?.split("-")?.[1]?.length || !row?.items?.[0]?.destination?.split("-")?.[0]?.length)) {
                    row.items[0].dest_note = select?.allowed?.find(s => s?.number === row?.items?.[0]?.destination?.replace('-', ''))?.context
                    row.items[0].destination = withDestinationNumber(row?.items?.[0]?.destination?.replace('-', ''))
                } else if (row?.items?.[0]?.destination?.split("-")?.length === 2 && row?.items?.[0]?.destination?.split("-")?.[0]?.length === 7) {
                    row.items[0].dest_note = select?.sip?.find(s => s?.number === row?.items?.[0]?.destination?.split("-")?.[0])?.context

                }
            } else {
                row?.items?.map(r => {

                    if (r?.extension?.split("-")?.length === 2 && (r?.extension?.split("-")?.[0] || r?.extension?.split("-")?.[1])) {
                        if (r?.extension?.split("-")?.[0]?.length === 7) {
                            r.ext_note = select?.sip?.find(s => +s?.number === +r?.extension?.split("-")?.[0])?.context
                        }           
                        if (r?.extension?.split("-")?.[1]?.length === 7) {
                            r.ext_note = r?.ext_note + " - " + select?.sip?.find(s => +s?.number === +r?.extension?.split("-")?.[1])?.context
                        }
                    }
                    if (r?.extension?.replace('-', '')?.length === 9 || r?.extension?.replace('-', '')?.length === 8) {
                        r.ext_note = select?.allowed?.find(s => +s?.number === +r?.extension?.replace('-', ''))?.context
                        if (r?.extension === '-anonymous') {
                            r.extension = withCallerNumber(r?.extension?.replace('-', ''), r.fr)
                        }
                        else if (r?.extension?.replace('-', '')?.length === 9) {
                            r.extension = withCallerNumber("374" + r?.extension?.replace('-', '')?.slice(1), r.fr)
                        } else {
                            r.extension = withCallerNumber("374" + r?.extension?.replace('-', ''), r.fr)
                        }
                    }

                    if (r?.destination?.split("-")?.length === 2 && r?.destination?.split("-")?.[1]?.length === 8) {
                        r.dest_note = select?.allowed?.find(s => +s?.number === +r?.destination?.split("-")?.[1])?.context
                        r.destination = withDestinationNumber("0" + r?.destination?.split("-")?.[1])
                    } else if (r?.destination?.split("-")?.length === 2 && (!r?.destination?.split("-")?.[1]?.length || !r?.destination?.split("-")?.[0]?.length)) {
                        r.dest_note = select?.allowed?.find(s => +s?.number === +r?.destination?.replace('-', ''))?.context
                        r.destination = withDestinationNumber(r?.destination?.replace('-', ''))
                    } else if (r?.destination?.split("-")?.length === 2 && r?.destination?.split("-")?.[0]?.length === 7) {
                        r.dest_note = select?.sip?.find(s => +s?.number === +r?.destination?.split("-")?.[0])?.context

                    }
                })
            }
            return row;
        })

        // }

        if (historyData1) {
            setHistory({
                ...historyData1,
                response: historyData1.response
                    ? { ...historyData1.response, docs: [...(historyData1.response.docs || [])] }
                    : historyData1.response,
            });
        } else {
            setHistory(historyData1);
        }
    }, [historyData1, select, REACT_APP_SERVER]);

    const pathname = location.pathname || '';
    const isHistoryActive = pathname === '/history';
    const isOperatorReportActive = pathname === '/operator_report' || pathname.startsWith('/operator_report/');
    const isTelegramActive = pathname.startsWith('/history_telegram');
    const isWhatsappActive = pathname.startsWith('/history_whatsapp');

    return (
        <>
            <Helmet>
                <title>
                    {menu.history[+localStorage.getItem('atsLang') || 1]}
                </title>
            </Helmet>
            <Wrapper>
                <div className="tableParent m-0">
                    <Paper sx={{ minWidth: 'fit-content', fontSize: 10, boxShadow: '0 4px 6px -2px rgba(0,0,0,0.06)' }}>
                        <Accordion expanded={expanded}>
                            <AccordionSummary
                                style={{
                                    boxShadow: 'rgba(0, 0, 0, 0.14) 0px 4px 0px -2px',
                                    padding: '0 30px',
                                    height: 80,
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                                aria-expanded="true"
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <div className="w-100"
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                        {showCallHistoryNav ? (
                                        <>
                                        <h1 style={{ fontSize: 20, margin: 0 }}>
                                            <Link
                                                to={`/history?${qs.stringify(query, { arrayFormat: "comma" })}`}
                                                style={{ color: isHistoryActive ? primaryColor : undefined, textDecoration: 'none' }}
                                            >
                                                {menu.history[+localStorage.getItem('atsLang') || 1]}
                                            </Link>
                                        </h1>
                                        </>
                                        ) : null}
                                        {showReportNav ? (
                                        <>
                                        {(showCallHistoryNav) ? <div className="header_border" style={{ height: 40, marginBottom: 15 }} /> : null}
                                        <h1 style={{ fontSize: 20, margin: 0 }}>
                                            <Link
                                                to={`/operator_report`}
                                                onClick={() => navigate('/operator_report')}
                                                style={{ color: isOperatorReportActive ? primaryColor : undefined, textDecoration: 'none' }}
                                            >
                                                {graphics.graphic[+localStorage.getItem('atsLang') || 1]}
                                            </Link>
                                        </h1>
                                        </>
                                        ) : null}

                                        {showTelegramNav && telegramIdForLink ? (
                                        <>
                                        {(showCallHistoryNav || showReportNav) ? <div className="header_border" style={{ height: 40, marginBottom: 15 }} /> : null}
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 8 }}>
                                            <h1 style={{ fontSize: 20, margin: 0 }}>
                                                <Link
                                                    to={`/history_telegram/${telegramIdForLink}`}
                                                    style={{ color: isTelegramActive ? primaryColor : undefined, textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 8 }}
                                                >
                                                    <TelegramIcon sx={{ fontSize: 22 }} />
                                                    Telegram
                                                </Link>
                                            </h1>
                                        </div>
                                        </>
                                        ) : null}
                                        {showWhatsappNav ? (
                                        <>
                                        <div className="header_border" style={{ height: 40, marginBottom: 15 }} />
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 8 }}>
                                            <h1 style={{ fontSize: 20, margin: 0 }}>
                                                <Link
                                                    to="/history_whatsapp"
                                                    style={{ color: isWhatsappActive ? '#25D366' : undefined, textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 8 }}
                                                >
                                                    <WhatsAppIcon sx={{ fontSize: 22, color: isWhatsappActive ? '#25D366' : 'inherit' }} />
                                                    {telecomunication?.whatsapp_title?.[+localStorage.getItem('atsLang') || 1] || 'WhatsApp'}
                                                </Link>
                                            </h1>
                                        </div>
                                        </>
                                        ) : null}
                                    </div>

                                    <span style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                        {profileData?.id === profileData?.clgroup && (
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    size="small"
                                                    checked={query.member_all === 'true'}
                                                    onChange={async (e) => {
                                                        const next = { ...query, limit: getHistoryPageSize(query.limit) };
                                                        if (e.target.checked) next.member_all = 'true';
                                                        else delete next.member_all;
                                                        navigate(`?${qs.stringify(next, { arrayFormat: 'comma', skipEmptyString: true })}`);
                                                        const yourDate = new Date();
                                                        const offset = yourDate.getTimezoneOffset();
                                                        yourDate.setTime(yourDate.getTime() - (offset * 60 * 1000));
                                                        const today = yourDate.toISOString().split('T')[0];
                                                        const callerVal = restrictToOwnHistory && employeeBuddy ? employeeBuddy : (next.caller || '');
                                                        await dispatch(historyRequest(getHistoryPageSize(next.limit), next.page || 1, {
                                                            endTime: next.endTime || today,
                                                            startTime: next.startTime || today,
                                                            number: next.number || '',
                                                            did: next.did || '',
                                                            caller: callerVal,
                                                            status: next.status || '',
                                                            disposition: next.disposition || '',
                                                            line: next.line || '',
                                                            direction: next.direction || '',
                                                            period: next.period || '',
                                                            virtual: next.virtual != null && next.virtual !== '' ? next.virtual : '',
                                                            ...(next.member_all === 'true' && { member_all: true }),
                                                        }));
                                                    }}
                                                    sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: primaryColor }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: primaryColor } }}
                                                />
                                            }
                                            label={historyHeader.groupHistoryAccess[+localStorage.getItem('atsLang') || 1]}
                                        />
                                        )}
                                        <CalendarMonthIcon style={{ transition: 'transform 0s', cursor: 'pointer' }}
                                            onClick={() => setExpanded(!expanded)} />
                                    </span>
                                </div>
                            </AccordionSummary>
                            <hr className="m-0" />

                            <AccordionDetails>
                                {REACT_APP_SERVER === 'Beeline' ? <HistoryFilter1 /> : <HistoryFilter restrictToOwnHistory={restrictToOwnHistory} lockedCaller={employeeBuddy || ''} />}
                            </AccordionDetails>
                        </Accordion>
                        <audio ref={audioRef} style={{ display: 'none' }} />
                        {trackList.length || currentTrack ? (
                            <>
                                <AudioPlayerBar
                                    onPrev={handlePrev}
                                    onNext={handleNext}
                                    onPlayPause={handlePlayerPlayPause}
                                    onSeek={handleSeek}
                                    onDownload={handleDownloadFile}
                                    currentTrack={currentTrack}
                                    playingId={playingId}
                                    progress={progress}
                                    duration={audioDuration}
                                    currentTime={currentTime}
                                    volume={volume}
                                    onVolumeChange={setVolume}
                                    playerLabel={playerLabel}
                                    canGoPrev={canGoPrev}
                                    canGoNext={canGoNext}
                                    formatTime={formatTime}
                                    formatFileSize={formatFileSize}
                                    formatFileDate={formatFileDate}
                                    langIndex={langIndex}
                                    onText={handleText}
                                    textLoading={!!loading}
                                    speed={speed}
                                    onSpeedChange={setSpeed}
                                    paperSx={{ position: sticky ? 'sticky' : 'static', top: 0, zIndex: 3, background: 'white', paddingBottom: '10px', mt: 0, mb: 2, p: 1.5, borderRadius: 2, border: '1px solid #e5e8ed', bgcolor: '#fff' }}
                                />
                            </>
                        ) : null}
                        {window.location.pathname === '/graphic' ?
                            <Graphics />
                            : window.location.pathname.includes('/history_telegram') ?
                                <HistoryChats />
                                :
                                <TableContainer>
                                    <Table stickyHeader aria-label="table">
                                        <TableHead>
                                            <TableRow className="sip_header">
                                                {history.map((column, i) =>{ 
                                                    if(i === 4 && profileData.id !== 10 && profileData.id !== 100) {
                                                        return null;
                                                    }
                                                    return (
                                                    <TableCell
                                                        style={i === 0 || i === history.length - 1 ? { padding: '5px 13px' } : { padding: 5 }}
                                                        key={i}
                                                        align="center"
                                                    >
                                                        {column[+localStorage.getItem('atsLang') || 1]}
                                                    </TableCell>
                                                )})}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody className="accordion" id="accordionExample"
                                            style={_.isEmpty(historyD?.response?.docs) ? { height: 'calc(100vh - 600px)' } : {}}>
                                            {!_.isEmpty(historyD?.response?.docs) ? historyD?.response?.docs?.map((row, _) => {
                                                if (row.items.length === 1) {
                                                    counter++
                                                    if (REACT_APP_SERVER === 'Ucom') {

                                                    }
                                                    return (
                                                        <React.Fragment key={row.items[0].id}>
                                                            <HistoryLine
                                                                track={trackList}
                                                                trackIndexSet={trackIndexSet}
                                                                playingId={playingId}
                                                                loading={loading} setIsOpen={setIsOpen} isOpen={isOpen}
                                                                counter={counter}
                                                                showHistoryIcon={(+profileData?.id === 10 || +profileData?.id === 5847 || +profileData?.id === 100) && parseCallHistory(row.items[0].call_history_s).length > 0}
                                                                historyOpen={callHistoryOpen === row.items[0].linkedid}
                                                                onHistoryClick={() => setCallHistoryOpen(callHistoryOpen === row.items[0].linkedid ? '' : row.items[0].linkedid)}
                                                                handleAudio={handleAudio} handleText={handleText}
                                                                r={row.items[0]} />
                                                            {(+profileData?.id === 10 || +profileData?.id === 5847 || +profileData?.id === 100) && callHistoryOpen === row.items[0].linkedid ? (
                                                                <CallHistoryList
                                                                    value={row.items[0].call_history_s}
                                                                    extension={row.items[0].extension}
                                                                    showWait={+profileData?.id === 10 || +profileData?.id === 100}
                                                                    playingId={playingId}
                                                                    textLoading={loading}
                                                                    onPlay={handleHistoryPlay}
                                                                    onText={handleHistoryText}
                                                                    playDisabled={!!(Cookies.get('viewer') && !profile?.isLimited)}
                                                                />
                                                            ) : null}
                                                        </React.Fragment>
                                                    );

                                                } else {
                                                    const firstItem = row.items[0]
                                                    const lastItem = row.items[row.items.length - 1]
                                                    const historyOnLast = firstItem?.status === 'Out Call' && String(firstItem?.transfer_call_s) === '1'
                                                    const historySource = historyOnLast ? lastItem : firstItem
                                                    const callHistoryRaw = historySource?.call_history_s
                                                    const showGroupHistory = +profileData?.id === 10 && parseCallHistory(callHistoryRaw).length > 0
                                                    const rows = row.items.map((r, ind) => {
                                                        counter++;

                                                        if (ind === 0) {
                                                            return (

                                                                <HistoryLine track={trackList} trackIndexSet={trackIndexSet} playingId={playingId}
                                                                    loading={loading} setIsOpen={setIsOpen}
                                                                    isOpen={isOpen} background={"#e5e5e5"}
                                                                    key={r.id} counter={counter}
                                                                    isEmotion={r.isEmotion}
                                                                    showHistoryIcon={!historyOnLast && showGroupHistory}
                                                                    historyOpen={callHistoryOpen === r.linkedid}
                                                                    onHistoryClick={() => setCallHistoryOpen(callHistoryOpen === r.linkedid ? '' : r.linkedid)}
                                                                    handleAudio={handleAudio}
                                                                    handleText={handleText}
                                                                    r={r} />

                                                            );
                                                        } else {
                                                            const isChildPlaying = playingId && (String(r.uniqueid || r.id) === String(playingId));
                                                            return (
                                                                <TableRow
                                                                    style={isOpen !== r.linkedid ? { display: 'none', } : {
                                                                        background: isChildPlaying ? '#edffdc' : '#efefef',
                                                                        cursor: 'pointer'
                                                                    }}
                                                                    className="sip_num" hover role="checkbox" tabIndex={-1}
                                                                    key={r.id}>

                                                                    <TableCell
                                                                        align="center">
                                                                        {REACT_APP_SERVER === 'Ucom' ? '' :

                                                                            <CachedIcon
                                                                                sx={{
                                                                                    color: "#1976d2",
                                                                                }}
                                                                            />}
                                                                        {REACT_APP_SERVER === 'Ucom' ? r.disposition !== "ANSWERED" ?
                                                                            <IconForCall color={history1.callType[1].color}
                                                                                path={history1.callType[1].path} /> : r.ext_num ?
                                                                                <IconForCall
                                                                                    color={history1.callType[2].color}
                                                                                    path={history1.callType[2].path} /> :
                                                                                <IconForCall
                                                                                    color={history1.callType[0].color}
                                                                                    path={history1.callType[0].path} /> : null}

                                                                    </TableCell>
                                                                    <TableCell
                                                                        style={{ width: 100 / 8 + '%', fontSize: 10 }}
                                                                        align="center">
                                                                        {Utils.formatHistoryDateRange(r)}
                                                                    </TableCell>
                                                                    <TableCell
                                                                        data-tooltip-content={String(r.ext_note ?? '')}
                                                                        data-tooltip-id={String(r.id ?? '')}
                                                                        style={{ width: 100 / 8 + '%' }} align="center">
                                                                        <Tooltip className={"tooltip"} id={String(r.id ?? '')} />

                                                                        {r.transfer_from ? r.transfer_from : r.extension ? r.extension : ''}
                                                                    </TableCell>
                                                                    <TableCell
                                                                        style={{ width: 100 / 8 + '%' }} align="center">
                                                                        {Utils.secToHours(Number(r.duration || r.billsec) || 0)}
                                                                    </TableCell>
                                                                    {(profileData?.id === 10 || profileData?.id === 100) && <TableCell
                                                                        style={{ width: 100 / 8 + '%' }}
                                                                        align="center">
                                                                        {r?.wait_s ? r.wait_s : 0} {history1.seconds[localStorage.getItem('atsLang') || 1]}
                                                                    </TableCell>}
                                                                    <TableCell
                                                                        style={{ width: 100 / 8 + '%' }}
                                                                        align="center">
                                                                        {r.line && r.line !== 'null' ? r.line : r.ext_num ? r.ext_num[0] : ''}
                                                                    </TableCell>
                                                                    <TableCell
                                                                        style={{ width: 100 / 8 + '%' }}
                                                                        align="center">
                                                                        {r.in_num ? r.in_num : ''}
                                                                    </TableCell>
                                                                    <TableCell
                                                                        style={{ width: 100 / 8 + '%' }}
                                                                        align="center">
                                                                        {r.virtual ? Utils.displayShortNumber(r.virtual) : ''}
                                                                    </TableCell>
                                                                    <TableCell
                                                                        data-tooltip-content={
                                                                            (r.disposition === "ANSWERED" || row.items[0].disposition === 'ANSWERED') && String(r.channel || '').startsWith("SIP/10")
                                                                                ? "Caller"
                                                                                : (r.disposition === "ANSWERED" || row.items[0].disposition === 'ANSWERED')
                                                                                    ? "Receiver"
                                                                                    : ""
                                                                        }
                                                                        data-tooltip-id={`disposition-${String(r.id ?? '')}`}
                                                                        style={{ width: 100 / 8 + '%' }}
                                                                        align="center">
                                                                        <Tooltip className={"tooltip"} id={`disposition-${String(r.id ?? '')}`} />
                                                                        {(r.disposition === "ANSWERED" || row.items[0].disposition === 'ANSWERED') && String(r.channel || '').startsWith("SIP/10")
                                                                            ? "C"
                                                                            : (r.disposition === "ANSWERED" || row.items[0].disposition === 'ANSWERED')
                                                                                ? "R"
                                                                                : ((r.disposition != null && r.disposition !== '') || (row.items[0].disposition != null && row.items[0].disposition !== '')) ? String(r.disposition || row.items[0].disposition) : ''}
                                                                    </TableCell>
                                                                    <TableCell
                                                                        data-tooltip-content={String(r.dest_note ?? '')}
                                                                        data-tooltip-id={String(r.id ?? '')}
                                                                        style={{ width: 100 / 8 + '%' }}
                                                                        align="center">
                                                                        {r.transfer_to ? r.transfer_to : r.destination ? r.destination : ''}
                                                                    </TableCell>
                                                                    <TableCell
                                                                        style={{ width: 100 / 8 + '%' }} align="center">
                                                                        {r.rate ? r.rate :
                                                                            <DoNotDisturbIcon style={{ color: '#ccc' }} />}

                                                                    </TableCell>
                                                                    <TableCell align="center"
                                                                        style={{
                                                                            width: 100 / 8 + '%',
                                                                            cursor: 'pointer'
                                                                        }}>
                                                                        {(Cookies.get('viewer') && !profile.isLimited) || !canListenToRecording(r) ?
                                                                            <PlayCircleIcon style={{ color: '#ccc' }} /> :
                                                                            isChildPlaying ?
                                                                                <PauseCircleIcon onClick={() => handleAudio(r)}
                                                                                    style={!r.isAudio ? { color: '#ccc' } : { color: color }} /> :
                                                                                <PlayCircleIcon onClick={() =>
                                                                                    handleAudio(r)}
                                                                                    style={!r.isAudio ? { color: '#ccc' } : { color: color }} />
                                                                        }
                                                                        {(Cookies.get('viewer') && !profile.isLimited) || !canListenToRecording(r) || !rowHasSpeechBuddy(r, speechbuddy) ?
                                                                            <ChatBubbleIcon style={{ color: '#ccc', pointerEvents: 'none' }} /> :
                                                                            loading === (r.uniqueid || r.id) ?
                                                                                <Loader size={20} /> :
                                                                                <ChatBubbleIcon onClick={() =>
                                                                                    handleText(r)}
                                                                                    style={!r.isAudio ? { color: '#ccc' } : (r.isEmotion || completed.find(l => l.id === r.linkedid)) ? { color: color } : { color: '#52658c' }} />
                                                                        }
                                                                        {historyOnLast && ind === row.items.length - 1 && showGroupHistory ? (
                                                                            <HistoryIcon
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation()
                                                                                    setCallHistoryOpen(callHistoryOpen === r.linkedid ? '' : r.linkedid)
                                                                                }}
                                                                                style={{ color: callHistoryOpen === r.linkedid ? color : '#52658c', cursor: 'pointer' }}
                                                                            />
                                                                        ) : null}
                                                                    </TableCell>

                                                                </TableRow>
                                                            );
                                                        }
                                                    })
                                                    return [
                                                        ...rows,
                                                        +profileData?.id === 10 && callHistoryOpen === row.items[0]?.linkedid
                                                            ? <CallHistoryList key={`call-history-${row.linkedid || row.items[0]?.id}`} value={callHistoryRaw} extension={historySource?.extension} showWait={profileData?.id === 10 || profileData?.id === 100} playingId={playingId} textLoading={loading} onPlay={handleHistoryPlay} onText={handleHistoryText} playDisabled={!!(Cookies.get('viewer') && !profile?.isLimited)} />
                                                            : null,
                                                    ]
                                                }

                                            }) :
                                                <TableRow className="sip_num" role="checkbox" tabIndex={-1}>
                                                    <TableCell colSpan={11} align="center">
                                                        {historyStatus === "request" ? graphics['loading'][+localStorage.getItem('atsLang') || 1] : graphics['no data'][+localStorage.getItem('atsLang') || 1]}
                                                    </TableCell>
                                                </TableRow>}
                                            <TableRow className="sip_num" role="checkbox" tabIndex={-1}>
                                                <TableCell className="p-0" colSpan={2} align="right">
                                                    {graphics['total'][+localStorage.getItem('atsLang') || 1]}
                                                </TableCell>
                                                <TableCell className="p-0" colSpan={4} align="center">
                                                    {Utils.secToHours(duration ? duration : 0)}
                                                </TableCell>
                                                <TableCell className="p-0" colSpan={2} align="left">
                                                    {graphics['total call count'][+localStorage.getItem('atsLang') || 1]}
                                                </TableCell>
                                                <TableCell className="p-0" colSpan={5} align="center">
                                                    {count || 0}
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                        }
                        {window.location.pathname === '/graphic' ? null :
                            <div className="foot_footer d-flex align-items-center justify-content-end">
                                <a href={link + `/history/exel?page=${query.page || 1}&userId=${profileData.id}&disposition=${query.disposition || ''}&line=${query.line || ''}&status=${query.status || ''}&endTime=${query.endTime || new Date().toISOString()}&startTime=${query.startTime || new Date().toISOString()}&number=${query.number || ''}&did=${query.did || ''}&caller=${restrictToOwnHistory && employeeBuddy ? employeeBuddy : (query.caller || '')}&period=${query.period || ''}`}>Excel</a>

                                <TablePagination
                                    className="hello"
                                    labelRowsPerPage={graphics['rows per page'][+localStorage.getItem('atsLang') || 1]}
                                    rowsPerPageOptions={[10, 25, 100, 500, 1000]}
                                    component="div"
                                    count={count || 1}
                                    rowsPerPage={historyLimit}
                                    page={page - 1 || 0}
                                    onPageChange={async (event, newPage) => await handleChangePage(newPage)}
                                    onRowsPerPageChange={async (ev) => await handleLimit(ev)}
                                />
                            </div>}

                    </Paper>
                </div>

                {!_.isEmpty(choose) ? <ChooseEmotion handleText={handleText} open={choose} setOpen={setChoose} /> : null}

                {!_.isEmpty(emotions) ? <Emotions open={emotions} setOpen={setEmotions} /> : null}
            </Wrapper>

        </>
    );
}

export default History;
